import {TransferenciaRecursoSolicitacao} from "@components/recurso/transferencias/TransferenciaRecursoSolicitacao.tsx";
import {GetSolicitacaoTransferenciaRecurso} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {IRecursoTransferenciaSolicitacao} from "@models/recurso/IRecursoTransferencia";
import {IRecursoTransferenciaSolicitacaoFiltroDto} from "@models/recurso/RecursoTransferenciaDto";
import {Divider, Grid, Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer";
import React, {useEffect, useState} from "react";

interface RecursoSolicitacaoTransferenciaPageProps extends DefaultPageProps {
    filtros?: IRecursoTransferenciaSolicitacaoFiltroDto;
}

export function RecursoSolicitacaoTransferenciaPage(props: RecursoSolicitacaoTransferenciaPageProps) {

    const [transferencias, setTransferencias] = useState<IRecursoTransferenciaSolicitacao[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10});

    useEffect(() => {
        if (pagination.page == 0) {
            setPagination({...pagination, page: 1});
            return;
        }
        setPagination(prev => ({...prev, loading: true}))

        GetSolicitacaoTransferenciaRecurso({...props.filtros}, pagination).then(x => {
            if (x.status == "Success") {
                setTransferencias(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })
    }, [pagination.page, pagination.ignoreCache]);

    useEffect(() => {
        if (props.pageProps != null) {
            setPagination({...props.pageProps.pagination})
        }
    }, [props.pageProps]);


    return (
        <DefaultContainer permissaoNecessaria={['CriarRecurso', 'EditarRecurso']}
                          pageProps={{pagination, setPagination}}
                          component={Paper}>
            <Grid container>
                <Grid size={12}>

                </Grid>
                <Grid size={12}>
                    <Divider/>
                    {transferencias.map((x) => {
                        return <TransferenciaRecursoSolicitacao key={x.id} transferencia={x}/>;
                    })}
                    <Divider/>
                </Grid>
            </Grid>
        </DefaultContainer>
    );
}